<script lang='ts'>
export default {
  name: 'CompaniesLocationStoresBulkUpdateInGmb',
}
</script>
<script setup lang='ts'>
import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { KkBox, KkButton } from '../../../../components/base'
import { KkInfo } from '../../../../components/ui'
import { storeToRefs } from 'pinia'
import { useBulkUpdateInGmbStore } from '../../../../stores/companies/location/stores/bulkUpdateInGmb'
import StoresModal from '../../../../components/Modals/StoresModal.vue'
import type { Store } from '../../../../components/domains/location/stores/types'
const store = useStore()

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const bulkUpdateInGmbStore = useBulkUpdateInGmbStore()
interface Emits {
  (e: 'update-title'): void
  (e: 'update-progress'): void
  (e: 'update-breadcrumbs'): void
}
defineEmits<Emits>()
const currentCompanyUuid = computed<string>(() => route.params.company_uuid as string)
const storeIds = computed<string[]>(() => route.params.storeIds as string[])
const stores = computed<Store[]>(() => store.getters['companiesStores/stores'])

const readStores = (companyUuid: string) => store.dispatch('companiesStores/readStores', companyUuid)

const selectedStores = computed<Store[]>(() => {
  return stores.value.filter(s => storeIds.value.includes(s.id))
})

const showSelectedStoresModal = ref<boolean>(false)

const {
  bulkUpdateInGmbLoading,
} = storeToRefs(bulkUpdateInGmbStore)
const {
  bulkUpdateInGmb
} = bulkUpdateInGmbStore

const openSelectedStoresModal = (): void => {
  showSelectedStoresModal.value = true
}

const onSubmit = async(): Promise<void> => {
  bulkUpdateInGmb({ companyUuid: currentCompanyUuid.value, storeIds: storeIds.value })
    .then(() => {
      router.push({ name: 'CompaniesLocationStores' })
    })
}

const load = (): void => {
  if (!route.params.storeIds || route.params.storeIds.length === 0) router.push({ name: 'CompaniesLocationStores' })
  readStores(currentCompanyUuid.value)
}
load()
</script>
<template>
  <KkBox>
    <template #content>
      <KkInfo>
        {{ t('pages.CompaniesLocationStoresBulkUpdateInGmb.info') }}
      </KkInfo>
      <div class="selectedStores">
        <i18n-t keypath="pages.CompaniesLocationStoresBulkUpdateInGmb.selectedStoresCount" tag="p">
          <span class="selectedStores__link u-colorPrimary" @click="openSelectedStoresModal">{{ t('labels.storesCount', storeIds.length) }}</span>
        </i18n-t>
      </div>
    </template>
    <template #footer>
      <div class="c-button c-button--right">
        <KkButton
          color="secondary"
          outlined
          :text="t('labels.cancel')"
          :disabled="bulkUpdateInGmbLoading"
          :to="{ name: 'CompaniesLocationStores', params: { company_uuid: currentCompanyUuid }}"
        />
        <KkButton
          class="saveButton"
          color="primary"
          :text="t('labels.confirm')"
          :disabled="bulkUpdateInGmbLoading"
          @click="onSubmit"
        />
      </div>
    </template>
  </KkBox>
  <StoresModal
    v-if="showSelectedStoresModal"
    :header-label="$t('pages.CompaniesLocationStoresBulkUpdateInGmb.selectedStores')"
    :store-names="selectedStores.map(s => s.attributes.name)"
    @close="showSelectedStoresModal = false"
  />
</template>
<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.selectedStores {
  margin-top: 20px;
}
.saveButton {
  margin-left: 16px;
}
</style>
